import React from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { ActionButton } from "../actionButton/ActionButton";
const Dislike = ({ status, onPress }) => {
    const dislikeText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.DISLIKE, prefix: PREFIX });
    return (React.createElement(ActionButton, { alignment: "left", icon: "close", status: status, testID: "dislike-button", text: dislikeText, onPress: onPress }));
};
export { Dislike };
